import React, { InputHTMLAttributes, useCallback, useContext, useMemo, useState } from 'react'
import { AiOutlinePlusSquare } from 'react-icons/ai'
import { ImMinus } from 'react-icons/im'
import ReactInputMask from 'react-input-mask'
import AdminUserContext from '../../context/AdminUser'
import useApi from '../../hooks/useApi'
import { TextInput } from '../../Korbantech/components/Inputs/TextInput'
import Modal from '../../Korbantech/components/Modal'
import { Alternatives } from '../../types/Alternatives'

export const AlternativesFields = ({ alternatives, ...props }: Props) => {

    const api = useApi()
    const { state: user } = useContext( AdminUserContext )
    const [alternativesCount, setAlternativeCount] = useState<number>(alternatives ? 0 : 1)
    const [alternative, setAlternative] = useState<Alternatives>()
    const [modal, setModal] = useState<boolean>()

    const handleDelete = useCallback(async (id: string) => {
        await api.delete(`admin/alternatives/${id}`).then(res => {
            window.location.reload()        
        }).catch(console.log)
    }, [api])

    const confirmDelete = useCallback((item: Alternatives) => {
        setAlternative(item)
        setModal(true)
    }, [setAlternative, setModal])


    const renderAlternatives = useMemo(() => {
        let alternative = []
        for (let i = 0; i < alternativesCount; i++) {
            alternative.push(
                <div key={i} className="grid grid-cols-5 col-span-5 gap-x-6">
                    <div className='col-span-4' key={`${i}a`}>
                        <TextInput required name={`questions[${props.name}][alternatives][${i}][alternative]`} className={'bg-gray-200 rounded border border-gray-600 text-gray-700 my-2'} />
                    </div>
                    <div className='col-span-1 flex' key={`${i}p`}>
                        <ReactInputMask
                                  required
                                   mask={"9.99"}
                                   maskChar={"0"}
                                   name={`questions[${props.name}][alternatives][${i}][points]`} 
                                   className={'w-full focus:outline h-10 border px-2 bg-gray-200 rounded border border-gray-600 text-gray-700 my-2'} 
                                   min="0" max="2"
                                   pattern="[0-9]+([,\.][0-9]+)?"
                                   />
                        {(i + 1) === alternativesCount &&
                            <div className=' justify-center flex items-center cursor-pointer ml-2 ' onClick={() => setAlternativeCount(prev => prev - 1)}>
                                <ImMinus className='text-red-600' />
                            </div>
                        }
                    </div>
                </div>)
        }
        return alternative
    }, [alternativesCount, props])

    return (
        <div className='grid grid-cols-6 gap-x-6'>
            <div className='col-span-4'>
                <div className='text-lg font-semibold'>Alternativa</div>
            </div>
            <div className='col-span-1'>
                <div className='text-lg font-semibold'>Peso</div>
            </div>
            <div className='col-span-1'>

            </div>
            {alternatives?.map(item => (
                <div key={item.id} className='col-span-6 grid grid-cols-6 gap-x-6'>
                    <input hidden name={`questions[${props.name}][alternatives][${item.id}][id]`} defaultValue={item.id}/>
                    <div className='col-span-4' key={`${item.id}a`}>
                        <TextInput
                            required
                          defaultValue={item.alternative}
                            name={`questions[${props.name}][alternatives][${item.id}][alternative]`} className={'bg-gray-200 rounded border border-gray-600 text-gray-700 my-2'} />
                    </div>
                    <div className='col-span-1' key={`${item.id}p`}>
                    <ReactInputMask
                                  required
                                   mask={"9.99"}
                                   maskChar={"0"}
                                   defaultValue={item.points}
                                   name={`questions[${props.name}][alternatives][${item.id}][points]`} 
                                   className={'w-full focus:outline h-10 border px-2 bg-gray-200 rounded border border-gray-600 text-gray-700 my-2'} 
                                   min="0" max="2"
                                   pattern="[0-9]+([,\.][0-9]+)?"
                                   />
                    </div>
                    {user?.is_super_admin ? 
                    <div className='flex items-center'>
                        <button type='button' className='col-span-1 border py-1 px-3 bg-red-600 text-white rounded-lg' onClick={() => confirmDelete(item)}>
                            Deletar
                        </button>
                    </div>
                     : ''}
                </div>
            ))}
            {renderAlternatives}
            <button className='flex col-span-5 justify-center p-2 items-center border border-dotted 
                                 border-black text-md my-2'
                type={'button'} onClick={() => setAlternativeCount(prev => prev + 1)}>
                <AiOutlinePlusSquare className='mr-2' /> Adicionar Alternativa
            </button>
            <Modal open={modal} onClickCloseButton={() => setModal(false)}>
                <div className='flex flex-col p-2'>
                    <strong>Deseja mesmo deletar a alternativa :</strong>
                    ( {alternative?.alternative} ) que vale ( {alternative?.points} ) pontos
                    {alternative &&
                        <div className='flex justify-between'>
                            <button className='bg-primary-dark mt-3 py-1 px-2 rounded-md' onClick={() => setModal(false)}>
                                        Cancelar
                            </button>
                            <button className='bg-red-500 mt-3 py-1 px-2 rounded-md text-white' onClick={() => handleDelete(alternative.id)}>
                                        Confirmar e deletar
                            </button>
                        </div>
                    }

                </div>
            </Modal>
        </div>
    )
}
interface Props extends InputHTMLAttributes<HTMLInputElement> {
    alternatives?: Alternatives[]
}